import { useAppSelector } from '@app/store/hooks';
import type { Role } from '@features/auth';
import { useMemo } from 'react';

import { normalizeAuthUser } from '../utils/normalizeUser';
import { hasRole, type RoleMode } from '../utils/roles';

export function useAuth() {
  const status = useAppSelector((s) => s.auth.status);
  const rawUser = useAppSelector((s) => s.auth.user);
  const user = useMemo(() => (rawUser ? normalizeAuthUser(rawUser) : null), [rawUser]);
  const error = useAppSelector((s) => s.auth.error);

  const roles = user?.role ? [user.role] : [];
  const isAuthenticated = status === 'authenticated' && user !== null;

  return {
    status,
    user,
    error,
    roles,
    isAuthenticated,
    hasRole: (required: readonly Role[] | undefined, mode: RoleMode = 'any') =>
      hasRole(roles, required, mode),
  };
}
